'use client';

import { useCapturePostHogException } from '@/components/entities/analytics/components/PostHog/hooks/useCapturePostHogException';
import { ErrorFallback } from '@/components/features/layout/ErrorFallback';

export default function GlobalError(props: { error: Error & { digest?: string }; reset: () => void }) {
  useCapturePostHogException(props.error, 'global');

  return (
    <html lang="en" data-scroll-behavior="smooth">
      <body>
        <ErrorFallback reset={props.reset} />
      </body>
    </html>
  );
}
